export var TripMatchStatus;
(function (TripMatchStatus) {
    TripMatchStatus["MatchPending"] = "PENDING";
    TripMatchStatus["MatchAccepted"] = "ACCEPTED";
    TripMatchStatus["MatchActive"] = "ACTIVE";
    TripMatchStatus["MatchSold"] = "SOLD";
    TripMatchStatus["MatchSoldCanceled"] = "SOLD_CANCELED";
    TripMatchStatus["MatchRefundedCanceled"] = "REFUNDED_CANCELED";
    TripMatchStatus["MatchPostponed"] = "POSTPONED";
    TripMatchStatus["MatchInactive"] = "INACTIVE";
    TripMatchStatus["MatchPartnerDeclined"] = "PARTNER_DECLINED";
    TripMatchStatus["MatchTravelerCanceled"] = "TRAVELER_CANCELED";
    TripMatchStatus["MatchPartnerCanceled"] = "PARTNER_CANCELED";
    TripMatchStatus["MatchZicassoCanceled"] = "ZICASSO_CANCELED";
    TripMatchStatus["MatchZicassoMatchError"] = "ZICASSO_MATCH_ERROR";
})(TripMatchStatus || (TripMatchStatus = {}));
export var SalesStage;
(function (SalesStage) {
    SalesStage["NeedsFollowUp"] = "NEEDS_FOLLOW_UP";
    SalesStage["NeedsProposal"] = "NEEDS_PROPOSAL";
    SalesStage["ProposalSent"] = "PROPOSAL_SENT";
})(SalesStage || (SalesStage = {}));
